interface EvidenceAvailability {
  id: string;
  videoUrl?: string;
}

/** IDs whose media can actually be mounted and sought by VideoPreview. */
export function getPlayableEvidenceIds(
  evidence:
    | EvidenceAvailability
    | EvidenceAvailability[]
    | null
    | undefined,
): Set<string> {
  const items = Array.isArray(evidence) ? evidence : evidence ? [evidence] : [];
  return new Set(
    items
      .filter((item) => Boolean(item.videoUrl?.trim()))
      .map((item) => item.id),
  );
}

export function shouldMountEvidencePlayer(args: {
  hasVideoData: boolean;
  isFinalReview: boolean;
  citationsEnabled: boolean;
  isReportSigned: boolean;
}): boolean {
  return (
    args.hasVideoData &&
    (args.isReportSigned || (args.isFinalReview && args.citationsEnabled))
  );
}
